//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import PROJECT_ROLES from '@/constants/project-roles'
import ModalErrorUsers from '@/components/Projects/users/ModalErrorUsers.vue'
import MessageWithoutHeader from '@/components/Shared/MessageWithoutHeader.vue'
import ProjectSupervisorCollaboratorList from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/ProjectSupervisorCollaboratorList.vue'
import ModalSupervisorCollaborator from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/ModalSupervisorCollaborator.vue'
import AddSupervisorModal from '@/components/Projects/NewProjectSteps/StepSupervisorCollaborator/supervisor/AddSupervisorModal.vue'
import NewProjectsWizardButtons from '@/components/Projects/NewProjectWizardButtons.vue'
import CircularButton from '@/components/Shared/CircularButton.vue'
import AddCollaboratorModal from './collaborator/AddCollaboratorModal.vue'
import CustomInvitationModal from '~/components/Projects/users/CustomInvitationModal.vue'
import MassiveImportSupervisorsCollaboratorsModal from '~/components/Projects/NewProjectSteps/StepSupervisorCollaborator/MassiveImportSupervisorsCollaboratorsModal.vue'
import MassiveImportInfoSupervisorsCollaboratorsModal from '~/components/Projects/NewProjectSteps/StepSupervisorCollaborator/MassiveImportInfoSupervisorsCollaboratorsModal.vue'
import GearFill from '~/assets/svg/gear-fill.svg'

export default {
  name: 'StepSupervisorCollaborator',
  components: {
    Multiselect,
    ModalErrorUsers,
    ProjectSupervisorCollaboratorList,
    ModalSupervisorCollaborator,
    AddSupervisorModal,
    CustomInvitationModal,
    MessageWithoutHeader,
    NewProjectsWizardButtons,
    AddCollaboratorModal,
    GearFill,
    CircularButton,
    MassiveImportSupervisorsCollaboratorsModal,
    MassiveImportInfoSupervisorsCollaboratorsModal,
  },
  async fetch() {
    this.$store.commit('loading', true)
    await this.getEmployeesInProject()
    this.$store.commit('loading', false)
  },
  data() {
    return {
      employeeTypesList: [
        { value: PROJECT_ROLES.COLLABORATOR, label: 'Colaborador' },
        { value: PROJECT_ROLES.SUPERVISOR, label: 'Supervisor' },
      ],
      employeeType: [],
      isShowCustomMessage: false,
      isShowModalAddUsers: false,
      isShowModalCollaborators: false,
      isShowModalSupervisors: false,
      isShowModalErrorUsers: false,
      isShowModalMassiveImportSupervisorsCollaborators: false,
      isShowModalInfoMassiveImportSupervisorsCollaborators: false,
      term: '',
      textModalErrorUsers: '',
      employees: [],
      employees_in_project: [],
      supervisorsCollaboratorsInfo: [],
    }
  },
  computed: {
    ...mapGetters({
      getBaseProject: 'project/getBaseProject',
    }),
    employeeTypeFilter() {
      if (!this.employeeType) {
        return null
      }
      return this.employeeType.value
    },
    supervisors() {
      return this.employees_in_project.filter(
        (employee) =>
          employee.projectRole?.employee_type === PROJECT_ROLES.SUPERVISOR
      )
    },
    collaborators() {
      return this.employees_in_project.filter(
        (employee) =>
          employee.projectRole?.employee_type === PROJECT_ROLES.COLLABORATOR
      )
    },
    hasAtLeastOneSupervisorAndOneCollaborator() {
      return this.supervisors.length > 0 && this.collaborators.length > 0
    },
  },
  methods: {
    handleBack() {
      this.$emit('back')
    },
    handleContinue() {
      this.$emit('next')
    },
    toggleModalCustomMessage() {
      this.isShowCustomMessage = !this.isShowCustomMessage
    },
    toggleModalAddUsers() {
      this.isShowModalAddUsers = !this.isShowModalAddUsers
    },
    toggleModalSupervisors() {
      this.isShowModalSupervisors = !this.isShowModalSupervisors
    },
    openAddSupervisorModal() {
      this.isShowModalAddUsers = false
      this.isShowModalSupervisors = true
    },
    openAddCollaboratorModal() {
      this.isShowModalAddUsers = false
      this.isShowModalCollaborators = true
    },
    toogleModalErrorUsers() {
      this.isShowModalErrorUsers = !this.isShowModalErrorUsers
    },
    toggleMassiveImportSupervisorsCollaboratorsModal() {
      this.isShowModalMassiveImportSupervisorsCollaborators = !this
        .isShowModalMassiveImportSupervisorsCollaborators
    },
    toggleMassiveImportInfoSupervisorsCollaboratorsModal() {
      this.isShowModalInfoMassiveImportSupervisorsCollaborators = !this
        .isShowModalInfoMassiveImportSupervisorsCollaborators
    },
    async finishMassiveSupervisorCollaborators() {
      this.toggleMassiveImportInfoSupervisorsCollaboratorsModal()
      await this.getEmployeesInProject()
    },
    async refreshEmployeesInProject() {
      await this.getEmployeesInProject()
    },
    handleUserWithError(message) {
      this.textModalErrorUsers = message
      this.isShowModalErrorUsers = true
    },
    async getEmployees(companyId) {
      const employees = await this.$repository.user.findWithProjectRolesByCompany(
        {
          company: companyId,
        }
      )

      return employees.map((employee) => {
        const projectRole = employee.project_roles?.find(
          (projectRole) =>
            projectRole.project === this.getBaseProject.id &&
            projectRole.deleted_at === null
        )
        return {
          ...employee,
          projectRole: projectRole || null,
        }
      })
    },
    async getEmployeesInProject() {
      this.$store.commit('loading', true)
      this.employees = await this.getEmployees(this.$strapi.user.company.id)
      const tempUsers = await this.$repository.user.findWithProjectRolesByProject(
        {
          project: this.getBaseProject.id,
        }
      )

      const employeeIds = tempUsers.map((employee) => employee.id)

      const tempInvitations = await this.$repository.invitation.findAll({
        _where: {
          user: employeeIds,
        },
      })

      this.employees_in_project = tempUsers.map((employee) => {
        const invitation = tempInvitations.find(
          (invitation) => invitation.user === employee.id
        )
        const projectRole = employee.project_roles?.find(
          (projectRole) =>
            projectRole.project === this.getBaseProject.id &&
            projectRole.deleted_at === null
        )
        return {
          ...employee,
          invitation: invitation || null,
          projectRole: projectRole || null,
        }
      })
      this.$store.commit('loading', false)
    },
    async updateSupervisorCollaborator(selectedOption) {
      await this.$repository.projectRoles.update(selectedOption.id, {
        employee_type: selectedOption.employee_type,
      })
      if (selectedOption.employee_type === PROJECT_ROLES.COLLABORATOR) {
        await this.$repository.user.update(selectedOption.user, {
          project: selectedOption.project,
        })
        await this.$repository.supervisorAssignments.deleteBySupervisorAndProject(
          selectedOption.user,
          selectedOption.project
        )
      } else {
        await this.$repository.user.update(selectedOption.user, {
          project: null,
        })
      }
      this.getEmployeesInProject()
    },
    sendSupervisorsCollaboratorsDetails(users) {
      this.supervisorsCollaboratorsInfo = users
      this.toggleMassiveImportSupervisorsCollaboratorsModal()
      this.toggleMassiveImportInfoSupervisorsCollaboratorsModal()
      this.$emit('massive-users-details', users)
    },
  },
}
